const SENSITIVE_KEYS = /(^|_)(email|phone|message|token|password|auth_code|session_id)($|_)/i;
const SENSITIVE_NAME_KEYS = new Set(['name', 'full_name', 'contact_name', 'user_name']);
const CAMPAIGN_PARAMETERS = new Set([
  'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'dclid',
]);

export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-T93EWL2RPH';

export const analyticsEnabled = () => (
  typeof window !== 'undefined'
  && Boolean(GA_MEASUREMENT_ID)
  && (process.env.NODE_ENV === 'production' || process.env.REACT_APP_GA_DEBUG === 'true')
);

const cleanValue = (value) => {
  if (typeof value === 'string') return value.slice(0, 100);
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'boolean') return value;
  if (Array.isArray(value)) return value.slice(0, 200).map(cleanValue).filter(valueItem => valueItem !== undefined);
  if (value && typeof value === 'object') return cleanParameters(value);
  return undefined;
};

export function cleanParameters(parameters = {}) {
  return Object.fromEntries(Object.entries(parameters).flatMap(([key, value]) => {
    if (SENSITIVE_KEYS.test(key) || SENSITIVE_NAME_KEYS.has(key.toLowerCase())) return [];
    const cleaned = cleanValue(value);
    return cleaned === undefined ? [] : [[key, cleaned]];
  }));
}

export function sanitizedPageLocation(value = window.location.href) {
  const url = new URL(value, window.location.origin);
  for (const key of [...url.searchParams.keys()]) {
    if (!CAMPAIGN_PARAMETERS.has(key)) url.searchParams.delete(key);
  }
  url.hash = '';
  return url.toString();
}

export function initializeAnalytics() {
  if (!analyticsEnabled() || window.__softwareIqResearchGaInitialized) return;
  window.__softwareIqResearchGaInitialized = true;
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: false,
    cookie_domain: 'auto',
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
  });
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_MEASUREMENT_ID)}`;
  script.dataset.softwareiqAnalytics = 'research';
  document.head.appendChild(script);
}

export function updateAnalyticsConsent(consent) {
  if (!analyticsEnabled() || typeof window.gtag !== 'function') return;
  window.gtag('consent', 'update', {
    analytics_storage: consent === 'accepted' ? 'granted' : 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });
}

export function setAnalyticsUserId(userId) {
  if (!analyticsEnabled() || typeof window.gtag !== 'function') return;
  window.gtag('set', { user_id: userId || null });
}

export function trackEvent(eventName, parameters = {}) {
  if (!analyticsEnabled() || typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, cleanParameters({ app_surface: 'research', ...parameters }));
}

export function trackPageView() {
  trackEvent('page_view', {
    page_title: document.title,
    page_location: sanitizedPageLocation(),
    page_path: window.location.pathname,
  });
}
